module.exports = __webpack_public_path__ + "img/Marlins.33220ec4.png";